export default __webpack_public_path__ + "media/images/logos/portfolio_logo_green-d259f1248c49eab3812625d48b85f711.svg";